import React from 'react';
import { Wallet } from 'lucide-react';
import { useWalletModal } from '@solana/wallet-adapter-react-ui';
import { useWallet } from '../hooks/useWallet';

/**
 * WalletButton Component - Standalone wallet connection UI
 *
 * Displays:
 * - "Connect Wallet" button when disconnected
 * - Shortened wallet address when connected
 * - Click to open wallet modal for connecting/disconnecting
 *
 * This component is completely independent and can be easily
 * modified, styled, or replaced without affecting other features.
 */
export default function WalletButton() {
    const { connected, connecting, shortAddress, disconnect } = useWallet();
    const { setVisible } = useWalletModal();

    /**
     * Handle wallet button click
     * - If connected: disconnect
     * - If not connected: show wallet selection modal
     */
    const handleClick = () => {
        if (connected) {
            disconnect();
        } else {
            setVisible(true);
        }
    };

    return (
        <button
            onClick={handleClick}
            disabled={connecting}
            className={`flex items-center gap-2 px-8 py-3 rounded-full font-semibold transition-all ${
                connected
                    ? 'bg-green-500/20 text-green-400 border border-green-500/50 hover:bg-green-500/30'
                    : 'bg-gradient-to-r from-orange-500 to-red-500 hover:shadow-lg hover:shadow-orange-500/50 hover:scale-105'
            } ${connecting ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
            <Wallet size={18} />
            {connecting ? 'Connecting...' : connected ? shortAddress : 'Connect Wallet'}
        </button>
    );
}
